import React from 'react';
import { Switch, Route } from 'react-router-dom';

import Login from './components/Login';
import FortgotPassowrd from './components/ForgotPassword';
import Resetpassword from './components/ResetPassword';
import Activation from './components/Activation';
import PreCheck from './components/PreCheck';

function AuthRoutes(props) {
  return (
    <React.Fragment> 
        <Switch>
          <Route path="/auth/pre-check/" exact component={() => <PreCheck {...props}/>}/>
          <Route path="/auth/login/" exact component={() => <Login {...props}/>}/>
          <Route path="/auth/forgot-password" exact component={() => <FortgotPassowrd {...props}/>}/>
          <Route path="/auth/reset-password/:uid/:token/" exact component={() => <Resetpassword {...props}/>}/>
          <Route path="/auth/activation/:uid/:token/" exact component={() => <Activation {...props}/>}/>   
        </Switch>
    </React.Fragment>    
  );
}

export default AuthRoutes;


